<template>
    <div class="card">
        <loading :active="isLoading"
                 :is-full-page="false"
        >
        </loading>
        <div class="card-header d-flex justify-content-between">
            <span>{{title}}</span>
            <span class="close" v-on:click.prevent="$emit('close-modal')">&times;</span>
        </div>
        <div class="card-body">
            <Form @submit="submit">
                <div class="form-row" v-if="operation==='registration' || operation==='login' || operation==='forgot_password'">
                    <div class="form-group  col-md-12">
                        <label for="email" class="col-form-label text-md-right">Электронная
                            почта</label>

                        <Field
                                type="email"
                                id="email"
                                class="form-control"
                                name="email"
                                rules="required|email"
                                autocomplete="email"
                                autofocus/>
                            <ErrorMessage name="email" v-slot="{ message }">
                                <div class="text-danger" role="alert">{{message}}</div>
                            </ErrorMessage>
                    </div>
                </div>
                <div class="form-row" v-if="operation==='code_password' || operation==='reset_password'">
                    <div class="form-group  col-md-12">
                        <label for="code" class="col-form-label text-md-right">Проверочный код</label>
                        <Field
                                type="text"
                                id="code"
                                class="form-control"
                                name="code"
                                rules="required"
                                :disabled="operation==='reset_password'"
                        />
                        <ErrorMessage name="email" v-slot="{ message }">
                            <div class="text-danger" role="alert">{{message}}</div>
                        </ErrorMessage>
                    </div>
                </div>
                <div class="form-row" v-if="operation==='registration' || operation==='login' || operation==='reset_password'">
                    <div class="form-group col-md-12">
                        <label for="password" class="col-form-label text-md-right">Пароль</label>

                        <Field
                                id="password"
                                type="password"
                                class="form-control"
                                rules="required"
                                name="password"/>
                            <ErrorMessage name="password" v-slot="{ message }">
                                <div class="text-danger" role="alert">{{message}}</div>
                            </ErrorMessage>
                    </div>
                </div>
                <div class="form-row" v-if="operation==='registration' || operation==='reset_password'">
                    <div class="form-group col-md-12">
                        <label for="password_confirmation" class="col-form-label text-md-right">Подтверждение пароля</label>
                        <Field
                                id="password_confirmation"
                                type="password"
                                class="form-control"
                                rules="required|confirmed:@password"
                                name="password_confirmation"/>
                            <ErrorMessage name="password_confirmation" v-slot="{ message }">
                                <div class="text-danger" role="alert">{{message}}</div>
                            </ErrorMessage>
                    </div>
                </div>
                <div v-if="isServerErrors">
                    <hr>
                    <div class="text-danger" v-for="(message, index) in serverErrors" v-bind:key="index">{{message}}</div>
                </div>
                <div v-else-if="isServerMessage">
                    <hr>
                    <div class="text-success">{{serverMessage}}</div>
                </div>
                <hr>
                <div class="form-row">
                    <div class="form-group col-md-12 d-flex align-items-center justify-content-between">
                        <button type="submit" class="btn btn-primary">
                            {{buttonTitle}}
                        </button>
                        <div class="d-flex flex-column">
                            <template v-if="operation=='login'">
                                <a href="#" @click.prevent="changeOperation('registration')">Регистрация</a>
                                <a href="#" @click.prevent="changeOperation('forgot_password')">Восстановить пароль</a>
                            </template>
                            <template v-else>
                                <a href="#" @click.prevent="changeOperation('login')">Вход</a>
                            </template>

                        </div>
                    </div>
                </div>
            </Form>
        </div>
    </div>

</template>

<script>
    import Loading from 'vue3-loading-overlay';
    import 'vue3-loading-overlay/dist/vue3-loading-overlay.css';
    import {Form, Field, ErrorMessage, defineRule, configure} from 'vee-validate'
    import {mapActions} from "vuex";
    import {required, email, confirmed} from '@vee-validate/rules';
    import {localize} from '@vee-validate/i18n'

    defineRule('required', required);
    defineRule('email', email);
    defineRule('confirmed', confirmed);
    configure({
        generateMessage: localize('ru', {
            messages: {
                required: 'Поле не может быть пустым',
                email: 'Неправильный формат электронной почты',
                confirmed: 'Пароли не совпадают',
            },
        }),
    });

    export default {
        name: 'UserLogin',
        components: {
            Loading,
            Form,
            Field,
            ErrorMessage,
        },
        props: {
            initialOperation: {
                type: String,
            },

        },
        data: function () {
            return {
                isLoading: false,
                operation: 'login',
                serverErrors: [],
                serverMessage: null,
            }
        },
        computed:{
            isServerErrors: function () {
                return this.serverErrors.length > 0
            },
            isServerMessage: function () {
                return !!this.serverMessage
            },
            title: function () {
                let title = 'Вход'
                switch (this.operation) {
                    case 'forgot_password':
                        title = 'Востановление пароля'
                        break
                    case 'code_password':
                        title = 'Введите код'
                        break
                    case 'reset_password':
                        title = 'Введите новый пароль'
                        break
                    case 'registration':
                        title = 'Зарегистрироваться'
                        break
                }
                return title
            },
            buttonTitle: function () {
                let title = 'Войти'
                switch (this.operation) {
                    case 'forgot_password':
                        title = 'Восстановить'
                        break
                    case 'code_password':
                        title = 'Отправить'
                        break
                    case 'reset_password':
                        title = 'Отправить'
                        break
                    case 'registration':
                        title = 'Зарегистрироваться'
                        break
                }
                return title
            }
        },
        methods: {
            ...mapActions([
                "login",
            ]),
            async submit(values) {
                try {
                    this.serverErrors.splice(0, this.serverErrors.length)
                    this.serverMessage = null
                    this.isLoading = true
                    let data = null
                    let operation = null
                    let nextStep = null
                    if (this.operation === 'login') {
                        data = {email: values["email"], password: values["password"]}
                        operation = 'login'
                        nextStep = 'exit'
                    } else if (this.operation === 'forgot_password') {
                        data = {email: values["email"]}
                        operation = 'forgotPassword'
                        nextStep = 'code_password'
                    } else if (this.operation === 'code_password') {
                        data = {code: values["code"]}
                        operation = 'checkPasswordCode'
                        nextStep = 'reset_password'
                    } else if (this.operation === 'reset_password') {
                        data = {
                            code: values["code"],
                            password: values["password"],
                            password_confirmation: values["password_confirmation"],
                        }
                        operation = 'resetPassword'
                        nextStep = 'exit'
                    } else if (this.operation === 'registration') {
                        data = {
                            email: values["email"],
                            password: values["password"],
                            password_confirmation: values["password_confirmation"],
                        }
                        operation = 'registration'
                        nextStep = 'exit'
                    }
                    let response = await this.$store.dispatch(operation, data)
                    if (response['errors']) {
                        Object.values(response['errors']).forEach((arr)=>
                        {
                            this.serverErrors.push(arr[0])
                        })
                    } else {
                        if (nextStep) {
                            if (nextStep == 'exit') {
                                this.$emit('close-modal')
                            } else {
                                this.changeOperation(nextStep)
                            }
                        }
                        if(response['message']) {
                            this.serverMessage = response['message']
                        }
                    }
                    this.isLoading = false
                } catch (error) {
                    console.log(error.data)
                }
            },
            changeOperation(operation) {
                this.operation = operation
                this.serverErrors.splice(0, this.serverErrors.length)
                this.serverMessage = null
            }
        },
        mounted() {
            if (this.initialOperation) {
                this.operation = this.initialOperation
            }
        },
    }
</script>

<style scoped>
    .card.login-card {
        width: 70%;
        max-width: 500px;
        margin: 15% auto;
    }

    @media (max-width: 575.98px) {
        .card.login-card {
            width: 100%;
        }
    }

</style>
